import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=5fb943d2&"
import script from "./userinfo.js?vue&type=script&lang=js&"
export * from "./userinfo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports